import { MediaBreakpoints } from 'common/utils/helpers/theme.helpers';
import styled from 'styled-components';

export const ProductCardContainer = styled.div<{ $isActive? : boolean; }>`
    width: 176px;
    height: 197px;
    gap: 0px;
    border-radius: 8px;
    opacity: 0px;
    background: #FFFFFF;
    box-shadow: 0px 3px 5px 0px #00283B33,
                0px 0px 1px 0px #00283B4F;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    border: ${props => props.$isActive ? "1px solid black;" : "none;"}

    ${MediaBreakpoints.down('md')} {
        flex-direction: row;
        height: 99px;
        width: 95%;
    }
`;

export const ProductCardImageSection = styled.div`
    height: 132px;
    width: 100%;
    background: #EFFEF5;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MediaBreakpoints.down('md')} {
        width: 134px;
    }
`;

export const ProductCardTitle = styled.div`
    height: 65px;
    font-family: 'Eina 03';
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    color: #13544E;
    display: flex;
    align-items: center;

    ${MediaBreakpoints.down('md')} {
        margin: 0 auto;
    }
`;